// @ts-nocheck
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { fetchWorkspaceLawFirm, type ClientLicenseDto } from '../../services/ClientLicensesApiClient';

export type FirmLawFirmContextValue = {
  lawFirm: ClientLicenseDto | null;
  loading: boolean;
  error: string | null;
};

const FirmLawFirmContext = createContext(null as FirmLawFirmContextValue | null);

export function FirmLawFirmProvider({ children }: { children: React.ReactNode }) {
  const [lawFirm, setLawFirm] = useState(null as ClientLicenseDto | null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null as string | null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchWorkspaceLawFirm()
      .then((d) => {
        if (!cancelled) setLawFirm(d);
      })
      .catch((e) => {
        if (!cancelled) {
          setLawFirm(null);
          setError(e instanceof Error ? e.message : 'Failed to load law firm');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => ({ lawFirm, loading, error }), [lawFirm, loading, error]);

  return <FirmLawFirmContext.Provider value={value}>{children}</FirmLawFirmContext.Provider>;
}

/** Returns null when not under {@link FirmLawFirmProvider} (e.g. admin or client shell). */
export function useFirmLawFirmOptional(): FirmLawFirmContextValue | null {
  return useContext(FirmLawFirmContext);
}
